module.exports = __webpack_public_path__ + "static/mobile-2-1c700b1ce93775f41e480e4af0812e45.png";